import { render, staticRenderFns } from "./FieldConfiguratorDataProtection.vue?vue&type=template&id=41a95ade&"
import script from "./FieldConfiguratorDataProtection.vue?vue&type=script&lang=js&"
export * from "./FieldConfiguratorDataProtection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports